// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.propertySearch {
    margin: 0 1rem;
}

.propertySearch__field {
    width: 100%;
}

@media (max-width: 768px) {
    .propertySearch {
        margin: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/search/PropertySearch/PropertySearch.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":[".propertySearch {\n    margin: 0 1rem;\n}\n\n.propertySearch__field {\n    width: 100%;\n}\n\n@media (max-width: 768px) {\n    .propertySearch {\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
